import { Button, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenInputField from '../../../../../global_components/KenInputField';
import { makeStyles } from '@material-ui/styles';
import { ToastContainer, toast } from 'react-toastify';
import {
  getCourseEvaluationComponent,
  getEvaluationMasterDatas,
  postEvaluationMasterDatas,
} from '../../../../../Utils/apiServices';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import KenLoader from '../../../../../Components/KenLoader';

const stylebtn = {
  // fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '20px',
  /* identical to box height, or 143% */
  textAlign: 'center',
  color: '##272727',
  marginRight: '10px',
  borderRadius: '3px',
  alignItems: 'center',
  padding: '8px 12px',
};
const inputArr = [
  {
    type: 'text',
    id: 1,
    value: '',
  },
];
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',

    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    marginBottom: '15px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    height: '28px',
    width: '78px',
    textTransform: 'none',
    borderBottom: '1px solid transparent',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid transparent',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  normal: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  editbtn: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#272727',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '70%',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  sameLine: {
    marginTop: '40px',
    marginLeft: '-10px',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsMasterComponent = [
  {
    label: 'CLASS PARTICIPATION',
    value: 'CLASS PARTICIPATION',
  },
  {
    label:
      'CASE STUDIES AND ROLE PLAYS IN EITHER AUTHENTIC OR SIMULATED ENVIRONMENTS',
    value:
      'CASE STUDIES AND ROLE PLAYS IN EITHER AUTHENTIC OR SIMULATED ENVIRONMENTS',
  },
  {
    label: 'INDIVIDUAL AND GROUP ASSIGNMENTS',
    value: 'INDIVIDUAL AND GROUP ASSIGNMENTS',
  },
  {
    label: 'FIELD WORK',
    value: 'FIELD WORK',
  },
  {
    label: 'STUDENT BOARD ROOM DISCUSSIONS AND SUBMISSION',
    value: 'STUDENT BOARD ROOM DISCUSSIONS AND SUBMISSION',
  },
  {
    label: 'QUIZZES',
    value: 'QUIZZES',
  },
  {
    label: 'ESSAYS AND DISCUSSION PAPERS',
    value: 'ESSAYS AND DISCUSSION PAPERS',
  },
  {
    label: 'VERBAL AND WRITTEN PRESENTATIONS',
    value: 'VERBAL AND WRITTEN PRESENTATIONS',
  },
  {
    label: 'CAPSTONE AND RESEARCH PROJECTS',
    value: 'CAPSTONE AND RESEARCH PROJECTS',
  },
  {
    label: 'INTEGRATED LEARNING',
    value: 'INTEGRATED LEARNING',
  },
  {
    label: 'MID- TERM',
    value: 'MID- TERM',
  },
  {
    label: 'FINAL EXAMINATIONS',
    value: 'FINAL EXAMINATIONS',
  },
];
const GradingComponent = ({ CourseName }) => {
  const classes = useStyles();
  const [arr, setArr] = useState([]);

  const [openComponent, setOpenComponent] = useState(false);
  const [btnText, setbtnText] = useState();

  const ButtossnChnage = (e) => {
    setbtnText(e.target.value);
  };

  const [btnName, setbtnName] = useState('');
  const [btnState, setBtnState] = useState([]);
  const [minimumComponent, setMinimumComponent] = useState(0);
  const [minimumWeightage, setMinimumWeightage] = useState(0);
  const [maximumComponent, setMaximumComponent] = useState(0);
  const [maximumWeightage, setMaximumWeightage] = useState(0);
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  const addInput = () => {
    setOpenComponent((prev) => !prev);
  };

  const handleMaximumWeight = (e) => {
    setMaximumWeightage(e.target.value);
  };
  const handleMinimumWeight = (e) => {
    setMinimumWeightage(e.target.value);
  };
  const handleMinimumComponent = (e) => {
    setMinimumComponent(e.target.value);
  };
  const handleMaximumComponent = (e) => {
    setMaximumComponent(e.target.value);
  };
  const handleChange = (e) => {
    e.preventDefault();

    const index = e.target.id;

    setArr((s) => {
      const newArr = s.slice();
      newArr[index].value = e.target.value;
      setbtnName(newArr[index].value);

      return newArr;
    });
  };

  const [selectMasterComponent, setSelectMasterComponent] = useState(
    selectOptionsMasterComponent[0].value
  );
  const handleSelectChangeMasterComponent = (e) => {
    setSelectMasterComponent(e.target.value);
  };

  const handleTest1 = (buttonid) => {
    if (buttonid === 1) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 2) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 3) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
    if (buttonid === 4) {
      setMinimumComponent(40);
      setMinimumWeightage(0);
      setMaximumComponent(100);
      setMaximumWeightage(100);
    }
  };

  const idGenerater = () => {
    let id = Math.random().toString(36).substr(2, 9);
    return id;
  };
  const handleButton = () => {
    // if (selectMasterComponent === '') {
    //   toast.error('please enter a componet name', {
    //     position: 'top-right',
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    // } else {
    //   setArr((prevState, index) => {
    //     return [
    //       ...prevState,
    //       {
    //         id: idGenerater(),
    //         type: 'text',
    //         value: selectMasterComponent,
    //       },
    //     ];
    //   });
    //   setbtnText('');
    //   setOpenComponent((prev) => !prev);
    // }
    setArr((prevState, index) => {
      return [
        ...prevState,
        {
          id: idGenerater(),
          type: 'text',
          value: selectMasterComponent,
        },
      ];
    });
    setSelectMasterComponent('');
    setOpenComponent((prev) => !prev);
  };

  const deleteRowHandle = (i) => {
    setArr((prevState) => {
      return prevState.slice(0, -1);
    });
  };

  const handleButtonCancel = () => {
    setOpenComponent((prev) => !prev);
  };

  const ab = arr.map((item) => {
    return item.value;
  });

  const getCourseEvaluationComponentsss = () => {
    let payload = {
      courseName: CourseName,
    };
    getCourseEvaluationComponent(payload)
      .then((res) => {})
      .catch((err) => {
        console.log('eerororrror', err);
      });
  };
  const postEvaluationMasterData = () => {
    let payload = [
      {
        instituteId: '0015j00000rgtHcAAI',
        maxWgtPercentage: parseInt(maximumWeightage),
        minWgtPercentage: parseInt(minimumWeightage),
        maxComponents: parseInt(maximumComponent),
        minComponents: parseInt(minimumComponent),
        recordId: 'a3m1y0000005vTeAAI',

        // component: ab,
      },
    ];

    postEvaluationMasterDatas(payload)
      .then((res) => {
        toast.success(`${res.message}`);
        getEvaultionMasterData();
      })
      .catch((err) => {
        toast.error(`${err}`);
        console.log('eerororrror', err);
      });
  };

  const getEvaultionMasterData = () => {
    setLoading(true);
    getEvaluationMasterDatas().then((res) => {
      // setArr(masterComponent);
      setMinimumComponent(res.data[0].minComponents);
      setMinimumWeightage(res.data[0].minWgtPercentage);
      setMaximumComponent(res.data[0].maxComponents);
      setMaximumWeightage(res.data[0].maxWgtPercentage);
      // setData(res);
    });
    setLoading(false);
  };

  useEffect(() => {
    getCourseEvaluationComponentsss();
    getEvaultionMasterData();
  }, []);

  return (
    <>
      {loading && <KenLoader />}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />{' '}
      <Typography variant="h6" className={classes.title}>
        Grading component master list
      </Typography>
      <div>
        <Grid style={{ marginBottom: '10px' }} container spacing={1}>
          <Grid item xs={12} sm={4}>
            <KenSelectWrap
              label="Button Component"
              options={selectOptionsMasterComponent}
              value={selectMasterComponent}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeMasterComponent}
              required
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            style={{ marginTop: '20px', marginLeft: '10px' }}
          ></Grid>
        </Grid>

        {/* {arr.map((item, i) => {
          return (
            <Button
              variant="contained"
              style={stylebtn}
              onClick={() => handleTest1(1)}
            >
              {item.value}
            </Button>
          );
        })} */}
        {/* <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(1)}
        >
          TEST 1
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(2)}
        >
          TEST 2
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(3)}
        >
          MID TERM
        </Button>
        <Button
          variant="contained"
          style={stylebtn}
          onClick={() => handleTest1(4)}
        >
          END TERM
        </Button> */}
        {/* {btnState} */}
        {/* <Button variant="contained" style={stylebtn} onClick={addInput}>
          +
        </Button>
        <Button variant="contained" style={stylebtn} onClick={deleteRowHandle}>
          -
        </Button> */}
      </div>
      <Grid container spacing={2} className={classes.sameLine}>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Minimum Component'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={minimumComponent}
            onChange={(e) => handleMinimumComponent(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Minimum Weightage (%)'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={minimumWeightage}
            onChange={(e) => handleMinimumWeight(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>

        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Maximum Components'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={maximumComponent}
            onChange={(e) => handleMaximumComponent(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <KenInputField
            label={'Maximum Weightage (%)'}
            optionalLabel={false}
            // rows={4}
            // multiline={true}
            value={maximumWeightage}
            onChange={(e) => handleMaximumWeight(e)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        style={{ marginRight: '15px' }}
        className={classes.addButton}
        onClick={() => {
          postEvaluationMasterData();
        }}
      >
        Save
      </Button>
    </>
  );
};

export default GradingComponent;
